import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { WorkshopCard, LoadingCircle } from './';
import { Grid, Button, Box, Divider, Typography, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

const BACKEND_URL = process.env.REACT_APP_BACKEND;

const getFavourites = () => {
  try {
    return JSON.parse(localStorage.getItem('favourites')) ?? [];
  } catch {
    return [];
  }
};

const sortByName = (a, b) => {
  const nameA = `${a.name ?? ''} ${a.name ?? ''}`.toLowerCase();
  const nameB = `${b.name ?? ''} ${b.name ?? ''}`.toLowerCase();
  return nameA.localeCompare(nameB);
};

export default function WorkshopList() {
  const [workshops, setWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);

  const [favouriteWorkshops, setFavouriteWorkshops] = React.useState(getFavourites);
  const [favouritesValid, setFavouritesValid] = React.useState(true);
  const [favouritesError, setFavouritesError] = React.useState(false);

  const handleToggleFavourite = (workshopId) => {
    setFavouriteWorkshops((prev) => {
      const next = prev.includes(workshopId)
        ? prev.filter((id) => id !== workshopId)
        : [...prev, workshopId];

      localStorage.setItem('favourites', JSON.stringify(next));

      return next;
    });
  };

  useEffect(() => {

    if (favouriteWorkshops.length < 2) {
      setFavouritesValid(false);
    } else {
      setFavouritesValid(true);
      setFavouritesError(false);
    }

  }, [favouriteWorkshops]);

  const handleRegister = () => {

    if (favouriteWorkshops.length < 2) {
      setFavouritesValid(false);
      setFavouritesError(true);
    } else {
      window.location.href = "/register";
    }

  }

  useEffect(() => {

    let isMounted = true;

    const fetchData = async () => {
      try {
        const workshops_response = await axios.get(`${BACKEND_URL}/api/workshops?populate=*`);
        const workshop_data = workshops_response.data.data.sort(sortByName);

        const availability_response = await axios.get(`${BACKEND_URL}/api/workshops/available`);
        const availability_data = availability_response.data;

        const aggregate_data = workshop_data.map((workshop) => ({
          ...workshop,
          availableSpots: availability_data[workshop.documentId].sessions,
        }));

        if (isMounted) {
          setWorkshops(aggregate_data);
          setLoading(false);
        }

      } catch (err) {
        console.error(err);
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    }

  }, []);

  if (loading) return <LoadingCircle />

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          px: { xs: 2, sm: 4 },
          mb: 2,
          mt: 2,
        }}
      >
        <Alert
          icon={<TipsAndUpdatesIcon fontSize="inherit" />}
          severity="info"
          sx={{
            mb: 2,
            alignItems: 'center',
            width: 'fit-content',
            maxWidth: '100%',
          }}
        >
          <Typography variant="body2">
            <strong>Märgi huvipakkuvad töötoad lemmikuteks ❤️</strong>{' '}
            Nii leiad oma lemmikud registreerimisel kiiresti üles.
          </Typography>
        </Alert>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          position: 'sticky',
          top: 20,
          zIndex: 1000,
        }}
      >
        <Button
          onClick={handleRegister}
          size="large"
          variant="contained"
          color="primary"
          sx={{ mt: 1 }}
        >
          Registreeri
        </Button>
      </Box>

      <Divider sx={{ mt: 2, mb: 2 }} />

      <Grid container spacing={2} sx={{ mb: 2 }}>
        {workshops.map((ws) => (
          <Grid
            key={ws.documentId + '-grid'}
            size={{ lg: 3, md: 4, sm: 6 }}
          >
            <WorkshopCard
              workshop={ws}
              key={ws.documentId}
              favourite={favouriteWorkshops.includes(ws.documentId)}
              onToggleFavourite={handleToggleFavourite}
            />
          </Grid>
        ))}
      </Grid>

      <Dialog
        open={favouritesError}
        onClose={() => setFavouritesError(false)}
      >
        <DialogTitle>Hoiatus</DialogTitle>

        <DialogContent>
          Enne registreerimist pead valima lemmikuks vähemalt 2 erinevat töötuba.
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setFavouritesError(false)}>
            Sulge
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}
